module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABLUlEQVRoQ+3YwQ3CMAwFUHcSGIENWKXdwEducOXmbtBNYAQ2YJQgVyISom0SIppvSK8k1M+OnKQNMzsy/DQVULh6tQKFC0A/UYFr6SzmvL/JmYwwtwJKVwGmAszcisiQmhAkgDaTu4h0KQg0wJ6IhhQEIkALEI1ABUQjkAFRCHRAEGEBsIiwAphFWAJMIvQ4fUzZOL44tiWibcT/v7RYq/cBj7AK8MvJMmBEWAd0lgGdHr+tAsbgdQ0p4BTRutYYom10E3qRc+7c9/3hOc7aRuYzbxHwFvy4hEIlW+t3ZtYrpd7Ipp7J4K0AZoO3AFgMHh0QDB4ZEBU8KiA6eESAHpOTvs4htdGdiNxS2zYMIDVwuJ34fwHMfPlUjzDP6n3A564CSi+jWoFagcwMPAB/fKijuEFwNgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/展现菜单-01.png
// module id = mtQA
// module chunks = 0